import * as Output from "../../Text";

const monthlyCreditRateMandatory = (activeCreditContracts) =>
  activeCreditContracts === "yes";

export const monthlyCreditRateValidation = (field, fields) =>
  monthlyCreditRateMandatory(fields.activeCreditContracts) &&
  (!field || field.length <= 0)
    ? Output.resolve("generic.errors.M001_mandatoryFields")
    : undefined;
